import { Component, Input, OnInit } from '@angular/core';

import { CampaignDrawerService } from '@finder/shared/services/campaign-drawer/campaign-drawer.service';
import { CampaignDrawerGroupBase } from '@finder/shared/components/campaign-drawer-base/campaign-drawer-group-base';
import { ComponentHeaderComponent } from '../component-header/component-header.component';
import { CampaignDrawerCardComponent } from '../campaign-drawer-card/campaign-drawer-card.component';
import { CampaignDrawerDetailComponent } from '../campaign-drawer-detail/campaign-drawer-detail.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'finder-campaign-drawer-group',
    templateUrl: './campaign-drawer-group.component.html',
    styleUrls: ['./campaign-drawer-group.component.scss'],
    standalone: true,
    imports: [
        ComponentHeaderComponent,
        CampaignDrawerCardComponent,
        CampaignDrawerDetailComponent,
        CommonModule,
    ]
})
export class CampaignDrawerGroupComponent extends CampaignDrawerGroupBase implements OnInit {
    @Input() groupData: any;

    get isHeaderDataEmpty(): boolean {
        return Object.keys(this.groupData?.headerData ?? []).length === 0;
    }

    constructor(
        protected drawerService: CampaignDrawerService,
    ) {
        super(drawerService);
    }

    ngOnInit(): void {
        if (!this.groupData) {
            return;
        }

        this.setGroupId(this.groupData.blockId);
    }
}
